import React from 'react';
import './Aboutus.css';

const Aboutus = () => {
  return (
    <>
      <div className="aboutus-container">
        <div className="overlay-text">
          <h1>À propos de nous</h1>
          <p>Découvrez notre histoire et nos engagements.</p>
        </div>
      </div>
      <div className="content">
        <div className="section">
          <h2>Notre Mission</h2>
          <p>Notre mission est de fournir des solutions innovantes, fiables et durables en ingénierie électrique, automatisation industrielle et maintenance technique. Nous accompagnons nos clients dans l’optimisation de leurs installations, en garantissant performance, sécurité et efficacité énergétique.</p>
        </div>
        <div className="section">
          <h2>Notre Équipe</h2>
          <p>Notre équipe est composée d’ingénieurs, de techniciens et de spécialistes expérimentés, passionnés par la technologie et engagés à offrir un service de qualité. Grâce à une formation continue et à une expertise terrain solide, nous sommes capables de répondre aux exigences les plus complexes de nos clients dans différents secteurs industriels.</p>
        </div>
        <div className="section-valeur">
          <h2>Nos Valeurs</h2>
          <p>
            <span>Excellence : Offrir des prestations techniques de haut niveau.</span>
            <br />
            
            
            <span>Fiabilité : Être un partenaire de confiance à chaque étape de votre projet.</span>
            <br />
            
            <span>Innovation : Intégrer les dernières technologies pour anticiper vos besoins.</span>
            <br />
            
            <span>Sécurité : Assurer des interventions dans le respect total des normes et de la sécurité.</span>
            <br />
            
            <span>Engagement : Mettre la satisfaction client au cœur de nos priorités.</span>
            
            
            
          </p>
        </div>
      </div>
    </>
  );
};

export default Aboutus;